import axios from '@/libs/api.request'
//所有产品
export const apiProducttypeAll = data => {
  return axios.request({
    url: '/producttype/all',
    method: 'post',
    data
  })
}
//产品类型列表
export const apiProducttypeList = data => {
    return axios.request({
      url: '/producttype/list',
      method: 'post',
      data
    })
  }
//   删除
  export const apiProducttypeDelete = data => {
    return axios.request({
      url: '/producttype/delete',
      method: 'post',
      data
    })
  }
  //保存
  export const apiProducttypeSave = data => {
    return axios.request({
      url: '/producttype/save',
      method: 'post',
      data
    })
  }
//修改
  export const apiProducttypeUpdate = data => {
    return axios.request({
      url: '/producttype/update',
      method: 'post',
      data
    })
  }
//上下移动
export const apiProducttypeMove = data => {
  return axios.request({
    url: '/producttype/product-move',
    method: 'post',
    data
  })
}
  